import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BaseLayout } from '../components';
import LoginModal from '../components/LoginModal';

const LoginPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(true);

  // Redirect to home if already authenticated
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Redirect to home when login is successful
  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    navigate('/');
  };

  // Handle successful login from modal
  const handleModalClose = () => {
    if (isAuthenticated) {
      handleLoginSuccess();
    }
    // Don't allow closing the modal unless authenticated
  };

  // If authenticated, don't render anything (will redirect)
  if (!isLoading && isAuthenticated) {
    return null;
  }

  return (
    <BaseLayout className="login-page-container" backgroundColor="rgba(0, 0, 0, 0.8)">
      {/* Loading indicator */}
      {isLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          color: 'white',
          fontSize: '18px'
        }}>
          Đang kiểm tra đăng nhập...
        </div>
      )}

      {/* Background overlay */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1
      }} />

      {/* Login Modal - Always visible and can't be closed */}
      <LoginModal 
        isOpen={showLoginModal} 
        onClose={handleModalClose}
        forceLogin={true} // Force login mode - can't close modal
      />
    </BaseLayout>
  );
};

export default LoginPage;
